export default class Carousels {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Carousels;
		self.attachEvents();
	}

	static initCarousel($carousel) {
		const self = new Carousels;
		self.attachSlick($carousel);
	}

	static initTilesCarousel($carousel) {
		const self = new Carousels;
		self.attachSlickTiles($carousel);
	}

	attachEvents() {
		const self = this;

		// Carousels with .js-carousel-lazy are initialised on scroll by LazyLoad
		$('.js-carousel').not('.js-carousel-lazy').each(function(){
			self.attachSlick($(this));
		});

		$('.js-tiles-carousel').not('.js-carousel-lazy').each(function(){
			self.attachSlickTiles($(this));
		});

		// Ensuring any lazy loaded images in slick carousel are visible
		$('.js-carousel, .js-tiles-carousel').on('afterChange', function(event, slick, currentSlide, nextSlide) {
			$(this).find('.slick-slide.slick-active').each(function(){
				var $slide = $(this);

				if($slide.length > 0) {
					var image = $slide.find('img'),
						imageDataSrc = image.data('lazy-img');

					if(typeof imageDataSrc != 'undefined' && imageDataSrc.length > 0){
						if(image.attr('src') != imageDataSrc){
							image.attr('src', imageDataSrc);
						}
					}

					var $nextSlide = $slide.next('.slick-slide');

					if($nextSlide.length > 0) {
						var image = $nextSlide.find('img'),
							imageDataSrc = image.data('lazy-img');

						if(typeof imageDataSrc != 'undefined' && imageDataSrc.length > 0){
							if(image.attr('src') != imageDataSrc){
								image.attr('src', imageDataSrc);
							}
						}
					}
				}
			});
		});
	}

	attachSlick($carousel) {
		$carousel.slick({
	        //autoplay        : $carousel.data('slick-autoplay') || true,
	        autoplay        : false,
	        autoplaySpeed   : $carousel.data('slick-autoplay-speed') || 6000,
	        speed           : $carousel.data('slick-speed') || 600,
	        slidesToShow    : $carousel.data('slick-slides-to-show') || 7,
	        slidesToScroll  : $carousel.data('slick-slides-to-scroll') || 3,
	        dots            : $carousel.data('slick-dots') || false,
	        arrows          : $carousel.data('slick-arrows') || false,
	        fade            : $carousel.data('slick-fade') || false,
	        centerMode      : $carousel.data('slick-center-mode') || false,
	        centerPadding   : $carousel.data('slick-center-mode') || '30px',
	        useCSS          : $carousel.data('slick-use-css') || false,
	        swipe           : $carousel.data('slick-swipe') || true,
	        pauseOnHover    : $carousel.data('slick-pause-on-hover') || false,
	        pauseOnFocus    : $carousel.data('slick-pause-on-hover') || false,
	        vertical        : $carousel.data('slick-vertical') || false,
	        verticalSwiping : $carousel.data('slick-vertical') || false,
	        infinite        : $carousel.data('slick-infinite') || true,
	        asNavFor		: $carousel.data('slick-nav-for') || false,
	        focusOnSelect 	: $carousel.data('slick-focus-on-select') || false,
	        lazyLoad        : 'ondemand',
	        adaptiveHeight  : $carousel.data('slick-adaptive-height') || false,
	        responsive      : $carousel.data('slick-responsive') || [
	            {
	                breakpoint: 992,
	                settings: {
	                	// "dots": true,
	                	"arrows": false,
	                    slidesToShow: 5,
	                    slidesToScroll: 1
	                }
	            },
	            {
	                breakpoint: 767,
	                settings: {
	                	// "dots": true,
	                	"arrows": false,
	                    slidesToShow: 4,
	                    slidesToScroll: 1
	                }
	            },
	            {
	                breakpoint: 565,
	                settings: {
	                	// "dots": true,
	                	"arrows": false,
	                    slidesToShow: 3,
	                    slidesToScroll: 1
	                }
	            },
	        ]
	    });
	}

	attachSlickTiles($carousel) {
		$carousel.slick({
	        autoplay        : $carousel.data('slick-autoplay') || true,
	        autoplaySpeed   : $carousel.data('slick-autoplay-speed') || 4000,
	        speed           : $carousel.data('slick-speed') || 600,
	        slidesToShow    : $carousel.data('slick-slides-to-show') || 5,
	        slidesToScroll  : $carousel.data('slick-slides-to-scroll') || 1,
	        dots            : $carousel.data('slick-dots') || false,
	        arrows          : $carousel.data('slick-arrows') || false,
	        fade            : $carousel.data('slick-fade') || false,
	        centerMode      : $carousel.data('slick-center-mode') || false,
	        centerPadding   : $carousel.data('slick-center-mode') || '30px',
	        useCSS          : $carousel.data('slick-use-css') || false,
	        swipe           : $carousel.data('slick-swipe') || true,
	        pauseOnHover    : $carousel.data('slick-pause-on-hover') || false,
	        pauseOnFocus    : $carousel.data('slick-pause-on-hover') || false,
	        vertical        : $carousel.data('slick-vertical') || false,
	        verticalSwiping : $carousel.data('slick-vertical') || false,
	        infinite        : $carousel.data('slick-infinite') || true,
	        lazyLoad        : 'ondemand',
	        adaptiveHeight  : $carousel.data('slick-adaptive-height') || false,
	        responsive      : $carousel.data('slick-responsive') || [
	            {
	                breakpoint: 992,
	                settings: {
	                	// "dots": true,
	                	"arrows": false,
	                    slidesToShow: 3,
	                    slidesToScroll: 2,
	                    centerMode: true
	                }
	            },
	            {
	                breakpoint: 767,
	                settings: {
	                	// "dots": true,
	                	"arrows": false,
	                    slidesToShow: 2,
	                    slidesToScroll: 1,
	                    centerMode: true
	                }
	            },
	           	{
	                breakpoint: 565,
	                settings: {
	                	// "dots": true,
	                	"arrows": false,
	                    slidesToShow: 1,
	                    slidesToScroll: 1,
	                    centerMode: true
	                }
	            },
	        ]
	    });
	}
}
